import { render } from "./image_step.vue?vue&type=template&id=6825035d"
import script from "./image_step.vue?vue&type=script&lang=js"
export * from "./image_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__